import React, { useEffect, useState } from "react";
import defaultClasses from "./indicator.module.scss";
import Image from "../Image";
import { useAppContext } from "@overrides_venia/peregrine/context/app";
import { useLocation } from "@magento/venia-ui/lib/drivers";
import loadingPasta from "@Assets/images/loading_pasta.gif";
import logo_red from "../../../../assets/images/miscusi_logo_mobile_red.svg";
export const LoadingIndicator = _ref => {
  let {
    message = "what’s cookin’?",
    color,
    global = false,
    width = 200,
    height = 200,
    src = loadingPasta,
    classes,
    extraClasses = "",
    animate = true
  } = _ref;
  const internalClasses = classes ? classes : defaultClasses;
  const className = global ? internalClasses.global : internalClasses.root;
  return /*#__PURE__*/React.createElement("div", {
    className: "indicator ".concat(className, " ").concat(extraClasses)
  }, /*#__PURE__*/React.createElement(Image, {
    displayPlaceholder: false,
    alt: "Miscusi",
    height: height,
    width: width,
    src: src,
    title: "Miscusi",
    classes: {
      root: "".concat(internalClasses.indicator || defaultClasses.indicator, " ").concat(animate ? defaultClasses.animated : "")
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "message ".concat(internalClasses.message),
    style: color ? {
      color
    } : {}
  }, message));
};
export const GlobalLoadingIndicator = () => {
  const [isReady, setIsReady] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);
  const [showLoadingIndicator, setShowLoadingIndicator] = useState(true);
  const [{
    isPageLoading,
    pageLoaderFlags
  }, {
    actions: {
      setPageLoaderFlag
    }
  }] = useAppContext();
  const [disableLoadingScreen] = useState(localStorage.getItem("disableLoadingScreen") === "true");
  const location = useLocation();
  useEffect(() => {
    // Simulate a delay for loading styles or other resources
    setTimeout(() => {
      setIsReady(true);
    }, 20); // Adjust this time based on your actual resource loading time
  }, []);
  useEffect(() => {
    if (!isPageLoading && showLoadingIndicator) {
      setIsAnimating(true);
      setTimeout(() => {
        setIsAnimating(false);
        setShowLoadingIndicator(false);
      }, 300);
    }
  }, [isPageLoading, showLoadingIndicator]);
  useEffect(() => {
    setPageLoaderFlag({
      name: "default",
      value: true
    });
    setShowLoadingIndicator(true);
    setTimeout(() => {
      setPageLoaderFlag({
        name: "default",
        value: false
      });
    }, 10000); // Adjust this time based on your actual resource loading time
  }, [location.pathname]);
  return isReady && showLoadingIndicator && !disableLoadingScreen ? /*#__PURE__*/React.createElement(LoadingIndicator, {
    global: true,
    width: 200,
    height: 200,
    src: loadingPasta,
    extraClasses: isAnimating ? "uk-animation-fade uk-animation-reverse" : ""
  }) : null;
};
export default LoadingIndicator;